import ActivityCardSkeleton from '@Components/General/Skeletons/activity-card';
import { createFileRoute, defer } from '@tanstack/react-router';
import { contactActivitiesQueryOptions } from '@utils/queryOptions';
import ContactOverview from '@Views/Contacts/Contacts/ContactDetails/ContactOverview';

export const Route = createFileRoute('/contacts/$contactId_/')({
    component: ContactOverview,
    loader: opts =>
        opts.context.queryClient.prefetchQuery(
            contactActivitiesQueryOptions(opts.params.contactId),
        ),
    pendingComponent: ActivityCardSkeleton,
});
